import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Latest.css';
import {NavPages} from '../Tools/navPages/NavPages';
import {images} from '../images/images.js'
import {Loader} from '../Tools/Loader';

const LinkTemplate = (props) => {
	const divStyle = {
		backgroundColor: `${props.color}`
	}

	return(
		<Link to={`/${props.url}`}>
			<figure className='linkTemplate'>
				<img id={props.id} src={props.src} alt={props.name}/>
				<div id={props.id} className='captionBlock' style={divStyle} >
					<figcaption id={props.id}>{props.name}</figcaption>
					<time id={props.id}>{props.date}</time>
				</div>
			</figure>
		</Link>
	)
}	
export const Latest = () => {

	function screenLoader() {
       const fadeEffect =  setInterval(() => { 
         const preloader = document.querySelector('.preloader')
            if (!preloader.style.opacity) {
              preloader.style.opacity = '1'
            } 
            if (preloader.style.opacity > 0) {
              preloader.style.opacity = '-1'
              setTimeout(() => {preloader.style.display = 'none'}, 100)
            } else {
              clearInterval(fadeEffect)
            }
          }, 200)
      }


	useEffect(() => {
		screenLoader()
	}, [])


	return(
		<main className='latestContainer' >
			<Loader />
			<h1 className='sectionTitle'>Latest</h1>
			<LinkTemplate src={images.analogueAttic.cover} color='#645648' name='Label: Analogue Attic' date='23/05/2020' url='profile/analogue_attic'/>
			<hr className='space contentSeperator'/>
			<LinkTemplate src={images.church.cover} color='#30302D' name='Label: Church' date='23/05/2020' url='profile/church'/>
			<hr className='space contentSeperator'/>
			<LinkTemplate src={images.soulClap.cover} color='#322732' name='Artist: Soul Clap' date='23/05/2020' url='profile/soul_clap'/>
			<hr className='space contentSeperator'/>
			<NavPages />
		</main>
	);
}